import { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { TutorialPopup } from "../ui/tutorial-popup";
import { Box, IconButton } from "@mui/material";

// svg
import { ReactComponent as IconInformation } from "../../assets/svg/information.svg";
import videoPlanner from "../../assets/video/site-settings-drawing3-x2.mp4";
import { luckyorangeTrackEven } from "../../services/lucky-orange/luckyorange-events";
import { TooltipControlled } from "../ui/tooltip-custom";
import { hideTutorialHint, isTutorialHintHidden } from "../../utils/tutorial-utils";

export const TutorialPopupDrawing = ({ display }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleClickOpen = () => {
    setShowPopup(true);
    luckyorangeTrackEven("Site Settings: open hint");
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  const isHintHidden = isTutorialHintHidden("hideDrawingHint");

  useEffect(() => {
    if (display && !isHintHidden) {
      setShowPopup(true);
    }
  }, []);

  const hideHint = () => {
    setShowPopup(false);
    setShowTooltip(true);
    setTimeout(() => {
      setShowTooltip(false);
    }, 3000);
    // Store the flag so it doesn't show again
    hideTutorialHint("hideDrawingHint");
  };

  const handleCloseTooltip = () => {
    setShowTooltip(false);
  };

  const handleOpenTooltip = () => {
    setShowTooltip(true);
  };

  return (
    <>
      <TooltipControlled
        text="Click this button to open the hint again"
        open={showTooltip}
        handleClose={handleCloseTooltip}
        handleOpen={handleOpenTooltip}
      >
        <IconButton
          variant="outlined"
          onClick={handleClickOpen}
          sx={{ mt: "1px" }}
        >
          <IconInformation width="18px" height="18px" fill="#5D5F6A" />
        </IconButton>
      </TooltipControlled>

      {showPopup ? (
        <TutorialPopup
          title="How to define your site"
          handleClose={handleClose}
          open={showPopup}
          hideHint={hideHint}
          isHintHidden={isHintHidden}
        >
          <Box sx={{ margin: "0 auto" }}>
            <video
              width="640"
              height="360"
              autoPlay
              controls
              controlsList="nodownload noremoteplayback"
              disablePictureInPicture
              muted
            >
              <source src={videoPlanner} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <Box mt="24px">
              <Typography align="left" fontSize="14px" mb="8px">
                Using the bottom tool bar, you can directly draw on the map:
                draw either a rectangle or shape your site as polygon with
                multiple corner points. Simply click on the map to place the
                vertices of your polygon and complete by either double-clicking
                on the map or click back on the first point.
              </Typography>
            </Box>
          </Box>
        </TutorialPopup>
      ) : null}
    </>
  );
};
